import { useEffect } from "react";
import { useRouter } from "next/router";
import { getIsOfferingSupportsDirectBooking } from "@Modules/eventPage/utils/getIsDirectBookingListing";
import { IFormDetails } from "@Utils/hooks/form";
import { getLoggedInUserDetails } from "repoV2/utils/user&auth&login/loggedInUserDetails";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { URL_SEARCH_PARAMS } from "repoV2/features/Common/modules/URLsNRouting/URLsNRouting.constants";
import { USER_DETAILS_FORM_FIELDS } from "repoV2/constants/user&auth&login/userDetails";
import { isEmpty } from "@Utils";
import { FORM_FIELDS } from "../FormData";

export const usePrefillBookingFormValues = ({
    setFormDetails,
    isBooking,
}: {
    setFormDetails: IFormDetails.IReturnType["setFormDetails"];
    isBooking: boolean;
}) => {
    const router = useRouter();

    const prefillBookingFormValues = () => {
        if (!isBooking) return;

        const customerName =
            router.query[URL_SEARCH_PARAMS.CUSTOMER_NAME] || "";
        const customerEmail =
            router.query[URL_SEARCH_PARAMS.CUSTOMER_EMAIL] || "";
        const customerPhone =
            router.query[URL_SEARCH_PARAMS.CUSTOMER_PHONE] || "";
        const prefillFormDetails = [];

        if (customerName) {
            prefillFormDetails.push({
                key: USER_DETAILS_FORM_FIELDS.full_name,
                value: `${customerName}`,
                error: isEmpty(customerName),
            });
        }
        if (customerEmail) {
            prefillFormDetails.push({
                key: USER_DETAILS_FORM_FIELDS.email,
                value: `${customerEmail}`,
                error: isEmpty(customerEmail),
            });
        }
        if (customerPhone) {
            prefillFormDetails.push({
                key: USER_DETAILS_FORM_FIELDS.phone,
                value: `${customerPhone}`,
                error: isEmpty(customerPhone),
            });
        }

        if (!checkIsArrayEmpty(prefillFormDetails)) {
            setFormDetails(prefillFormDetails);
            return;
        }

        if (getIsOfferingSupportsDirectBooking()) {
            const loggedInUserDetails = getLoggedInUserDetails();
            if (!loggedInUserDetails) return;

            const lastUsedValues = [];
            if (loggedInUserDetails.fullName)
                lastUsedValues.push({
                    key: FORM_FIELDS.name,
                    value: loggedInUserDetails.fullName,
                });
            if (loggedInUserDetails.email)
                lastUsedValues.push({
                    key: FORM_FIELDS.email,
                    value: loggedInUserDetails.email,
                });
            if (loggedInUserDetails.country)
                lastUsedValues.push({
                    key: FORM_FIELDS.country,
                    value: loggedInUserDetails.country,
                });
            if (loggedInUserDetails.countryCode)
                lastUsedValues.push({
                    key: FORM_FIELDS.countryCode,
                    value: loggedInUserDetails.countryCode,
                });
            if (loggedInUserDetails.phone)
                lastUsedValues.push({
                    key: FORM_FIELDS.phone,
                    value: loggedInUserDetails.phone,
                });

            if (!checkIsArrayEmpty(lastUsedValues)) {
                setFormDetails(lastUsedValues);
            }
        }
    };

    useEffect(() => {
        prefillBookingFormValues();
    }, []);
};
